module.exports = __webpack_public_path__ + "img/4-low.1c89ece9.jpg";